import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import S3DirectoryListTaskForm from './forms/s3-directory-list-task-form';
import { s3DirectoryListTaskValidationSchema } from './schema.js';

export default function FileOperationS3DirectoryListNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'File Operation S3 Directory List Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'File Operation S3 Directory List Task',
        defaultLabel: 'File Operation S3 Directory List Task',
      }}
    >
      <CommonNode
        FormComponent={S3DirectoryListTaskForm}
        schemaResolver={s3DirectoryListTaskValidationSchema}
      />
    </NodeProvider>
  );
}
